/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import { createAction } from "@reduxjs/toolkit";
//Redux
import * as ACTIONTYPES from "../action-types/catalog";

const getProductListAction = createAction<any>(
  ACTIONTYPES.PRODUCT_LIST_GET_REQUESTED
);

const resetProductListAction = createAction(
  ACTIONTYPES.PRODUCT_LIST_RESET_REQUESTED
);

const getProductListForPDPAction = createAction<any>(
  ACTIONTYPES.PRODUCT_LIST_FOR_PDP_GET_REQUESTED
);

/**CODICE 72 */
const CODICE72_REQUESTED_ACTION = createAction<any, string>(
  ACTIONTYPES.CODICE72_REQUESTED
);

const VISIBLE_FACET_VENDOR_IN_COUNTRY_REQUEST_ACTION = createAction<any, string>(
  ACTIONTYPES.VISIBLE_FACET_VENDOR_IN_COUNTRY_REQUEST
);

const VISIBLE_FACET_VENDOR_IN_COUNTRY_SUCCESS_ACTION = createAction<any, string>(
  ACTIONTYPES.VISIBLE_FACET_VENDOR_IN_COUNTRY_SUCCESS
);

export {
  getProductListAction,
  resetProductListAction,
  getProductListForPDPAction,
  CODICE72_REQUESTED_ACTION,
  VISIBLE_FACET_VENDOR_IN_COUNTRY_REQUEST_ACTION,
  VISIBLE_FACET_VENDOR_IN_COUNTRY_SUCCESS_ACTION
};
